module.exports = __webpack_public_path__ + "img/luckIconLeft.113c25d1.png";